import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import {
    openShipmentDeletingPopup,
    selectIsEditingMode,
    selectShipment,
    selectShipmentDeletingStatus,
    selectShipmentDeliveryPriceHasChanged,
    setAccordions,
    setCollectingData,
    setDeliveryPriceHasChanged,
    setIsEditingMode,
} from "../shipmentSlice";
import RedSpinner from "../../../components/loaders/RedSpinner";
import { useEffect } from "react";
import { pushAlert } from "../../alerts/alertSlice";
import { useTranslation } from "react-i18next";
import { convertCurrencyNameToSymbol } from "../../../helpers/currency/currency";

const Upper = ({ trc, id }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isEditing = useSelector(selectIsEditingMode);

    const deletingStatus = useSelector(selectShipmentDeletingStatus);
    const shipment = useSelector(selectShipment);
    const deliveryPriceHasChanged = useSelector(
        selectShipmentDeliveryPriceHasChanged
    );
    const deliveryPrice = shipment["delivery-price"];
    
    console.log(deliveryPriceHasChanged);

    const handleEditButtonClick = () => {
        if (isEditing) {
            dispatch(setCollectingData({ value: true }));
        }

        if (!isEditing) {
            dispatch(
                setAccordions({
                    additionalOpened: true,
                    receiverOpened: true,
                })
            );
        }

        dispatch(setIsEditingMode({ isEditing: !isEditing }));
    };

    useEffect(() => {
        if (shipment && shipment.blocked) {
            dispatch(setIsEditingMode({ isEditing: false }));
            dispatch(setCollectingData({ value: false }));
        }
    }, [dispatch, shipment]);

    const handleDeleteButtonClick = () => {
        if (!shipment.id) {
            return;
        }

        dispatch(openShipmentDeletingPopup({ shipmentID: shipment.id }));
    };

    useEffect(() => {
        if (deliveryPriceHasChanged) {
            dispatch(
                pushAlert({
                    type: "Warning",
                    delay: 4000,
                    message: t("shipment.info.package_data_was_updated"),
                })
            );
            dispatch(setDeliveryPriceHasChanged(false));
        }
    }, [dispatch, deliveryPriceHasChanged]);

    return (
        <div className="w-full flex flex-col md:flex-row gap-y-3 items-start md:items-end justify-between mb-10">
            <div className="flex flex-col gap-2 sm:gap-3 items-start">
                <div className="text-left text-orange-600 text-xl">
                    ID: {id} |{" "}
                    {trc
                        ? `${t("shipment.tracking")}: ${trc}`
                        : `${t("shipment.no_tracking")}`}
                </div>
                <div className="text-xs flex">
                    <span className="mr-2 text-left">
                        {shipment["bill-id"]
                            ? t("shipment.control_price")
                            : t("shipment.approximate_price")}
                        :
                    </span>
                    <span className="font-bold text-left">
                        {shipment["delivery-price"] ??
                            t("shipment.not_enough_data")}
                        {shipment["delivery-price"] && "$"}
                    </span>
                </div>
                {shipment["etgb-price"] != null &&
                    shipment["etgb-price"] > 0 && (
                        <div className="text-xs flex">
                            <span className="mr-2 text-left">
                                {t("shipment.price_for_ETGB")}:
                            </span>
                            <span className="font-bold text-left">
                                {shipment["etgb-price"]}$
                            </span>
                        </div>
                    )}
                {shipment["over-200-euro-invoice-price"] != null &&
                    shipment["over-200-euro-invoice-price"] > 0 && (
                        <div className="text-xs flex flex-col xs:flex-row text-left">
                            <span className="mr-2 text-left">
                                {t("shipment.over_200_euro_invoice")}:
                            </span>
                            <span className="font-bold text-left">
                                {shipment["over-200-euro-invoice-price"]}$
                            </span>
                        </div>
                    )}
                {shipment["declared-price"] ? (
                    <div className="text-xs flex flex-col xs:flex-row text-left">
                        <span className="mr-2 text-left">
                            {t("shipment.additional_insurance")}:
                        </span>
                        <span className="font-bold text-left">
                            {(shipment["declared-price"] * 0.1).toFixed(1)}{" "}
                            {convertCurrencyNameToSymbol(
                                shipment["declared-price-currency"]
                            )}
                        </span>
                    </div>
                ) : (
                    <></>
                )}
            </div>
            <div
                className={`
                    flex 
                    flex-col xs:flex-row flex-wrap 
                    justify-center xs:justify-start md:justify-end 
                    gap-2 
                    w-full xs:w-fit
                `}
            >
                {/* Print package button  */}
                {/* <Button
                    disabled={true}
                    variant="contained"
                    sx={{
                        color: "white",
                        bgcolor: "#059669",
                        fontSize: "0.7rem",
                        ":hover": {
                            bgcolor: "#047857",
                        },
                    }}
                    onClick={handleEditButtonClick}
                >
                    Распечатать накладную(в разработке)
                </Button> */}
                {shipment && !shipment["blocked"] && (
                    <Button
                        variant="contained"
                        sx={{
                            color: "white",
                            bgcolor: "#dc2626",
                            fontSize: "0.7rem",
                            ":hover": {
                                bgcolor: "#b91c1c",
                            },
                        }}
                        onClick={handleDeleteButtonClick}
                    >
                        {t("shipment.delete_shipment_button")}
                        {deletingStatus === "pending" && (
                            <span className="ml-2">
                                <RedSpinner width={20} height={20} />
                            </span>
                        )}
                    </Button>
                )}
                {shipment && !shipment["blocked"] && (
                    <Button
                        variant="contained"
                        sx={{
                            color: "white",
                            bgcolor: isEditing ? "#047857" : "#059669",
                            fontSize: "0.7rem",
                            ":hover": {
                                bgcolor: "#047857",
                            },
                        }}
                        onClick={handleEditButtonClick}
                    >
                        {isEditing
                            ? t("shipment.save_shipment_button")
                            : t("shipment.edit_shipment_button")}
                    </Button>
                )}
            </div>
        </div>
    );
};

export default Upper;
